export default {
  drawerVisible: true,
  snackbar: {
    text: '',
    color: '',
    timeout: 3500,
    show: false,
  },
  overlay: false,
};
